import { render, staticRenderFns } from "./notification-campaign-form.vue?vue&type=template&id=3e68742d"
import script from "./notification-campaign-form.vue?vue&type=script&lang=js"
export * from "./notification-campaign-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports